import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <span className="brand-icon">🎮</span>
          HomeMadeKahoot
        </Link>
        <div className="navbar-menu">
          {user ? (
            <>
              <Link to="/quiz" className="navbar-link">Quiz</Link>
              <Link to="/create-quiz" className="navbar-link">Create Quiz</Link>
              <Link to="/browse" className="navbar-link">Browse</Link>
              <Link to="/results" className="navbar-link">Results</Link>
              <span className="navbar-user">👤 {user.username}</span>
              <button onClick={handleLogout} className="btn btn-secondary btn-sm">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="navbar-link">Login</Link>
              <Link to="/register" className="btn btn-primary btn-sm">
                Sign Up
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

